<template>
    <div id="answerListGenericQuestionId" class="answer-list-content answer-list-generic-question">

        <!-- ----------------------------------------- -->
        <!-- GENERIC QUESTION ANSWERS -->
        <!-- ----------------------------------------- -->

        <div v-if="getCurrentQuestion && getCurrentQuestion.answers
                    && !getPatientBirthDate
                    && getCurrentAssessmentStatus !== getAssessmentStatuses.NO_OTHER_SYMPTOMS"
                class="answer-items">
            <div v-for="answer in getCurrentQuestion.answers" :key="answer.code" :ref="'answer-item-'+answer.code" class="answer-item">
                <span @click.once="handleClickAnswer(answer, getCurrentQuestion)" :id="'A_' + answer.code" class="answer-item-text color-primary">{{answer.text}}</span>
            </div>
        </div>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'AnswerListGenericQuestion',

        data() {
            return {
                isClickDisabled: false // This will help us to prevent multiple clicks/multiple answers.
            };
        },
        computed: {
            ...mapGetters({
                getAssessmentStatuses: 'ChatBotStore/getAssessmentStatuses',
                getCurrentAssessmentStatus: 'ChatBotStore/getCurrentAssessmentStatus',
                getCurrentQuestion: 'ChatBotStore/getCurrentQuestion',
                getPatientBirthDate: 'ChatBotStore/getPatientBirthDate',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue'
            })
        },
        updated: function () {
            this.isClickDisabled = false; // Answer list has been updated (we have a new set of answers), so we make sure that clicks are enabled.

            if (this.getCurrentQuestion !== null) {
                this.$nextTick(function () {
                    this.$emit('onAnswerListUpdated');
                });
            }
        },

        methods: {

            handleClickAnswer (clickedAnswer, question) {

                if (this.isClickDisabled === true) {
                    return; // Clicks are disabled, so do nothing else.
                }
                else {
                    this.isClickDisabled = true; // Clicks were enabled until now. We disable them now (so no other clicks are possible), then execute the actions for current click.
                }

                this.$emit("onClickedAnswer");

                let clickedAnswerElem = this.$refs['answer-item-'+clickedAnswer.code][0];
                clickedAnswerElem.classList.add('answer-item-clicked');

                setTimeout(() => {
                    this.$store.dispatch("ChatBotStore/selectAnswer", {
                        answer: clickedAnswer,
                        question: question
                    });
                }, 0); // Wait to animate the Selected Answer in theme color
            },

        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pathfinder/components/chatbot/answer-list/AnswerListGenericQuestion.vue